import { SchemeType } from '@/shared/types/api.types'

export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'

export const EUROPE_SCHEME_CODE = '5004'
export const EUROPE_VARIANT = 'europe'
export const WORLDWIDE_VARIANT = 'worldwide'
export const SINGLE_VARIANT = 'single'

export const MAX_DEPARTURE_DAY_WITHOUT_TODAY = 89
export const MAX_DEPARTURE_DAY_WITHOUT_TODAY_OUTBOUND = 179
export const MAX_DEPARTURE_DAY_WITHOUT_TODAY_USA = 59
export const MULTI_TRIP_RETURN_DAY = 180

export const PLAN_DESCRIPTION_SCHEME_MAPPING: Record<string, Record<string, string[]>> = {
  [SchemeType.WorldwideExcl]: {
    // Case 1
    [`${SchemeType.Worldwide},${SchemeType.WorldwideExcl}`]: [
      'outbound.select_plan.insurance_values.plan_desc.common',
      'outbound.select_plan.insurance_values.plan_desc.excl_all',
    ],
    // Case 2
    [`${SchemeType.FlyEurope},${SchemeType.WorldwideExcl}`]: [
      'outbound.select_plan.insurance_values.plan_desc.common',
      'outbound.select_plan.insurance_values.plan_desc.visa',
      'outbound.select_plan.insurance_values.plan_desc.appl_world',
    ],
    // Case 3
    [`${SchemeType.Regional},${SchemeType.WorldwideExcl}`]: [
      'outbound.select_plan.insurance_values.plan_desc.common',
      'outbound.select_plan.insurance_values.plan_desc.appl_world',
    ],
    // Case 4
    [`${SchemeType.WorldwideExcl}`]: [
      'outbound.select_plan.insurance_values.plan_desc.common',
      'outbound.select_plan.insurance_values.plan_desc.appl_world',
    ],
  },
  [SchemeType.Worldwide]: {
    // Case 5
    [`${SchemeType.Worldwide},${SchemeType.WorldwideExcl}`]: [
      'outbound.select_plan.insurance_values.plan_desc.common',
      'outbound.select_plan.insurance_values.plan_desc.excl',
    ],
    // Case 6
    [`${SchemeType.Worldwide}`]: [
      'outbound.select_plan.insurance_values.plan_desc.common',
      'outbound.select_plan.insurance_values.plan_desc.appl_world',
    ],
  },
  [SchemeType.Regional]: {
    // Case 7
    [`${SchemeType.Regional},${SchemeType.WorldwideExcl}`]: [
      'outbound.select_plan.insurance_values.plan_desc.common',
      'outbound.select_plan.insurance_values.plan_desc.gcc',
    ],
  },
  [SchemeType.FlyEurope]: {
    // Case 8
    [`${SchemeType.FlyEurope},${SchemeType.WorldwideExcl}`]: [
      'outbound.select_plan.insurance_values.plan_desc.schengen',
    ],
  },
}
